$(function() {

    var $document = $(document);

//    const api = Cookies.withAttributes({ path: '/', sameSite: 'strict', secure: true })

    var bookmark_items_list = [];
    var bookmark_items_data = [];

    var utils = {

        'cookieTest': function() {

            try {
              // Create cookie
              document.cookie = 'cookietest=1; SameSite=None; Secure';
              var ret = document.cookie.indexOf('cookietest=') != -1;
              // Delete cookie
              document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT; SameSite=None; Secure';
              return ret;
            }
            catch (e) {
              return false;
            }

        },

        'cookieSetup': function() {

            var currentCookie = Cookies.get('bookmark_items');
            if (!currentCookie) {
                Cookies.set('bookmark_items', utils.generateUUID());
            }

        },

    };

    var bookmarkApp = {

        'init': function() {
    /*
            var output = [];
            var outputObjs = {};

            var len = output.length;
            for (var i=0;i<len;i++) {
                outputObjs[output[i]] = constants[output[i]];
            }
            utils.putOutputs(prefix_display, outputObjs);
    */
//            hashCheck();

            var cookie_items = Cookies.get('bookmark_items');
            if (cookie_items) {
                bookmark_items_list = cookie_items.split(',');
            }
            bookmarkApp.loadItems();

        },

        'updateCounter': function() {
            var bookmarksCount = bookmark_items_list.length;
            $('.bookmarksCount').text(bookmarksCount);
            if (bookmarksCount > 0) {
                $('#myBookmarksListClear').show();
            } else {
                $('#myBookmarksListClear').hide();
            }
        },

        'updateLinks': function() {
            $('.addBookmarkItem').removeClass('added');
            for (key in bookmark_items_list) {
                $('.addBookmarkItem[data-item-id="'+bookmark_items_list[key]+'"]').addClass('added');
            }
        },

        'updateItems': function() {
            $('.listBookmarkItem').each(function() {
                var key = $(this).attr('data-item-id');
                if ($.inArray(key, bookmark_items_list) === -1) {
                    $(this).remove();
                }
            });
            if ($('.listBookmarkItem').length < 1) {
                $('#bookmarkItemsEmpty').removeClass('hide');
            }
        },

        'addItem': function(key) {
            if ($.inArray(key, bookmark_items_list) === -1) {
                bookmark_items_list.push(key);
                bookmarkApp.saveItems();
            }
        },

        'addItems': function(ids) {
            var keys = ids.split(',');
            for (key in keys) {
                if ($.inArray(keys[key], bookmark_items_list) === -1) {
                    bookmark_items_list.push(keys[key]);
                }
            }
            bookmarkApp.saveItems();
        },

        'removeItem': function(key) {
            if ($.inArray(key, bookmark_items_list) > -1) {
                var itemId = bookmark_items_list[key];
                bookmark_items_list = bookmark_items_list.filter(function(itemkey) {
                    return itemkey !== key
                });
                bookmarkApp.saveItems();
            }
        },

        'clearItems': function(key) {
            bookmark_items_list = [];
            bookmark_items_data = [];
            bookmarkApp.saveItems();
        },

        'saveItems': function() {
            if (bookmark_items_list.length > 0) {
                var cookie_items = [];
                for (key in bookmark_items_list) {
                    cookie_items.push(bookmark_items_list[key]);
                }
                Cookies.set('bookmark_items', cookie_items.join());
            } else {
                Cookies.remove('bookmark_items');
            }
            bookmarkApp.loadItems();
        },

        'loadItems': function() {
            bookmark_items_data = [];
            var bookmark_json = {};
            var bookmark_query = bookmark_items_list.join();
            if (bookmark_query !== '') {
                var postRequest = {
                    "query": "query($id: [QueryArgument!]) { entries(id: $id) { id, title, url } }",
                    "variables": { "id": bookmark_items_list }
                };
                var jqxhr = $.post('/api/', postRequest, function(bookmarkData) {
                    bookmark_json = bookmarkData.data.entries;
                    $.each(bookmark_json, function(key, obj) {
                        bookmark_items_data.push(obj);
                    });
                    bookmarkApp.outputItems();
                });
            } else {
                bookmarkApp.outputItems();
            }
        },

        'outputItems': function() {
            var html = '';
            if (Object.keys(bookmark_items_data).length > 0) {
                for (key in bookmark_items_data) {
                    var bookmark_item = bookmark_items_data[key];
                    html += '<li><a href="javascript.void(0);" class="removeBookmarkItem float-right" data-item-id="'+bookmark_item.id+'" alt="Remove">X</a><a href="'+bookmark_item.url+'" class="itemDetails" data-item-id="'+bookmark_item.id+'">'+bookmark_item.title+'</a></li>';
                }
                $('#myBookmarksListPrint').removeClass('hide');
            } else {
                $('#myBookmarksListPrint').addClass('hide');
            }
            $('#myBookmarksListNav').html(html);
            bookmarkApp.updateCounter();
            bookmarkApp.updateLinks();
            bookmarkApp.updateItems();
        }

    };

    $document.on('click', '.addBookmarkItem', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var id = $(this).attr('data-item-id');
        if ($.inArray(id, bookmark_items_list) === -1) {
            bookmarkApp.addItem(id);
        } else {
            bookmarkApp.removeItem(id);
        }
    });

    $document.on('click', '.addBookmarkItems', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var ids = $(this).attr('data-item-ids');
        bookmarkApp.addItems(ids);
    });

    $document.on('click', '.removeBookmarkItem', function(e) {
        e.preventDefault();
        var id = $(this).attr('data-item-id');
        bookmarkApp.removeItem(id);
    });

    $document.on('click', '.clearBookmarkItems', function(e) {
        e.preventDefault();
        bookmarkApp.clearItems();
    });

    bookmarkApp.init();

});
